module.exports = __webpack_public_path__ + "static/media/Inventor View.3c3516df.png";